import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import DiabetesDataService from '../services/DiabetesDataService';
export default function getTimelineGlucose(_x, _x2) {
  return _getTimelineGlucose.apply(this, arguments);
}

function _getTimelineGlucose() {
  _getTimelineGlucose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(startDate, endDate) {
    var diabetesDataService, params, diabetes, timelineData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            diabetesDataService = new DiabetesDataService();
            params = [{
              date: "ge".concat(moment(startDate).hour(0).minute(0).second(0).utc().toISOString())
            }, {
              date: "le".concat(moment(endDate).hour(23).minute(59).second(59).utc().toISOString())
            }, {
              _sort: '-date',
              _count: 100000,
              // TODO: any way to unlimit in fhir?
              _elements: 'effectiveDateTime,valueQuantity'
            }];
            _context.next = 4;
            return diabetesDataService.fetchData(params);

          case 4:
            diabetes = _context.sent;
            timelineData = [];
            diabetes.forEach(function (diabetesItem) {
              if (!diabetesItem.date || !diabetesItem.glucoseValue) {
                return;
              }

              timelineData.push({
                date: diabetesItem.date,
                value: diabetesItem.glucoseValue
              });
            });
            return _context.abrupt("return", timelineData.map(function (data) {
              if (data.value.split) {
                data.value = Number(data.value.split(' ')[0]);
              }

              return data;
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getTimelineGlucose.apply(this, arguments);
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getTimelineGlucose, "getTimelineGlucose", "/home/runner/html/nextcloud/apps/ehr/js/plugins/diabetes/src/timelineData/getTimelineGlucose.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();